/**
 * Search component.
 * @module components/theme/Search/Search
 */

import Search from '@arpav/components/ArpavTheme/Search/Search';

export default Search;
